import React from "react";
import Icon from "../atoms/Icon";
import Label from "../atoms/Label";
import ReadMore from "../molecules/ReadMore";
import { Desktop, MEDIUM, Mobile } from "../util/breakpoints";
import { markdownToJSX } from "../../util/transforms";
import Image from "../atoms/Image";
import useMediaQuery from '../util/useMediaQuery'

export default ({ label, title, text, link, image, translations }) => {
    const isMediumUp = useMediaQuery({ minWidth: MEDIUM });

    return (
        <section className="u-section-spacing u-background">
            <div className="o-featured">
                { image &&
                <div className="o-featured__media">
                    <Image className={ "o-featured__image" + (isMediumUp ? " o-featured__image--fit" : "") } image={ image }/>
                </div>
                }
                <div className="o-featured__item u-container">
                    <div className="o-featured__content u-background">
                        <Mobile>
                            <Icon className="o-featured__icon" iconName="icon-wave-horizontal"/>
                        </Mobile>
                        <Label text={ label }/>
                        { title && <h2>{ markdownToJSX(title) }</h2> }
                        <p>{ text }</p>
                        { link && <ReadMore isRed text={ link.title } link={ link } translations={ translations }/> }
                        <Desktop>
                            <Icon className="o-featured__icon" iconName="icon-wave-vertical"/>
                        </Desktop>
                    </div>
                </div>
            </div>
        </section>
    );
}
